import { supabase } from "../supabaseClient";

const BUCKET = "gallery";


function isFlyer(filename) {
  return filename.toLowerCase().startsWith("flyer");
}


/**
 * Capa = arquivo `flyer*` (case-insensitive); sem nenhum, o primeiro da
 * lista (que já chega ordenada alfabeticamente pelo `.list()` do Storage).
 * As fotos são todo o resto. Existia inline e duplicada de duas formas
 * diferentes em `listEvents` e `listEventPhotos` — unificada aqui.
 *
 * Exportada só para teste — não é chamada de fora deste módulo.
 */
export function pickCover(imageFiles) {
  const cover = imageFiles.find((f) => isFlyer(f.name)) || imageFiles[0] || null;
  const photos = cover ? imageFiles.filter((f) => f !== cover) : [];
  return { cover, photos };
}


function getPublicUrl(path) {
  const { data } = supabase.storage.from(BUCKET).getPublicUrl(path);
  return data?.publicUrl || null;
}


const MONTHS_PT = [
  "Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
  "Jul", "Ago", "Set", "Out", "Nov", "Dez",
];

/** Exportada só para teste — não é chamada de fora deste módulo. */
export function formatEventName(folderName) {
  const dateWithName = folderName.match(/^(\d{4})(\d{2})(\d{2})-(.+)$/);
  if (dateWithName) {
    const [, year, month, day, suffix] = dateWithName;
    const formatted = suffix
      .replace(/[-_]+/g, " ")
      .split(" ")
      .filter(Boolean)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
      .join(" ");
    return `${day} ${MONTHS_PT[parseInt(month, 10) - 1]} ${year} · ${formatted}`;
  }

  const dateOnly = folderName.match(/^(\d{4})(\d{2})(\d{2})$/);
  if (dateOnly) {
    const [, year, month, day] = dateOnly;
    return `${day} ${MONTHS_PT[parseInt(month, 10) - 1]} ${year}`;
  }

  const name = folderName
    .replace(/^\d+[-_\s]+/, "")
    .replace(/[-_]+/g, " ")
    .split(" ")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");

  return name || "Evento";
}


export async function listEvents() {
  if (!supabase) throw new Error("Supabase não configurado");


  const { data: folders, error } = await supabase.storage
    .from(BUCKET)
    .list("", {
      limit: 200,
      sortBy: { column: "name", order: "desc" },
    });

  if (error) throw error;


  const eventFolders = (folders || []).filter((item) => item.id === null);


  const events = await Promise.all(
    eventFolders.map(async (folder) => {
      const { data: files, error: filesError } = await supabase.storage
        .from(BUCKET)
        .list(folder.name, {
          limit: 200,
          sortBy: { column: "name", order: "asc" },
        });

      if (filesError || !files || files.length === 0) return null;



      const imageFiles = files.filter(
        (f) => f.id !== null && f.name !== ".emptyFolderPlaceholder"
      );

      if (imageFiles.length === 0) return null;

      const { cover, photos } = pickCover(imageFiles);

      return {
        id: folder.name,
        name: folder.name,
        displayName: formatEventName(folder.name),
        flyer: {
          name: cover.name,
          url: getPublicUrl(`${folder.name}/${cover.name}`),
        },
        photoCount: photos.length,
      };
    })
  );


  return events.filter(Boolean);
}


export async function listEventPhotos(eventId) {
  if (!supabase) throw new Error("Supabase não configurado");

  const { data: files, error } = await supabase.storage
    .from(BUCKET)
    .list(eventId, {
      limit: 200,
      sortBy: { column: "name", order: "asc" },
    });

  if (error) throw error;

  const imageFiles = (files || []).filter(
    (f) => f.id !== null && f.name !== ".emptyFolderPlaceholder"
  );

  const { photos } = pickCover(imageFiles);

  return photos.map((f) => ({
    name: f.name,
    url: getPublicUrl(`${eventId}/${f.name}`),
  }));
}
